import React from 'react';
import { TeamSummaryProps } from './types';
import { BLACK } from 'styles/colors';

const TeamSummary: React.FC<TeamSummaryProps> = ({
  teams,
  theme = 'light',
  size,
}) => {
  return (
    <div
      className="w-100 d-flex flex-column flex-md-row justify-content-center oswald-regular"
      style={{
        backgroundColor: theme === 'light' ? 'transparent' : BLACK,
        fontSize: `${size * 2}rem`,
        color: theme === 'light' ? BLACK : 'white',
        overflow: 'hidden',
      }}
    >
      {/* Team 1 */}
      <div
        className="team-summary-team d-flex align-items-stretch justify-content-end"
        style={{
          borderBottomColor: teams[0]?.attrs.colors?.primary,
          borderBottomStyle: 'solid',
          borderBottomWidth: '0.25rem',
        }}
      >
        {/* Team 1 name */}
        <div className="d-flex align-items-center flex-fill ps-4 pe-4 pt-3 pb-3">
          <div className="w-100 lh-1 text-md-end">{teams[0]?.name}</div>
        </div>
        {/* Team 1 score */}
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: teams[0]?.attrs.colors?.primary,
            fontWeight: 'bold',
            padding: `0 ${size * 1}rem`,
            minWidth: `${size * 4.5}rem`,
            color: 'white',
          }}
        >
          {teams[0]?.extra?.points}
        </div>
      </div>

      {/* Team 2 */}
      <div
        className="team-summary-team d-flex align-items-stretch justify-content-end"
        style={{
          borderBottomColor: teams[1]?.attrs.colors?.primary,
          borderBottomStyle: 'solid',
          borderBottomWidth: '0.25rem',
        }}
      >
        {/* Team 2 name */}
        <div className="d-flex align-items-center flex-fill ps-4 pe-4 pt-3 pb-3 order-md-2">
          <div className="w-100 lh-1">{teams[1]?.name}</div>
        </div>
        {/* Team 2 score */}
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: teams[1]?.attrs.colors?.primary,
            fontWeight: 'bold',
            padding: `0rem ${size * 1}rem`,
            minWidth: `${size * 4.5}rem`,
            color: 'white',
          }}
        >
          {teams[1]?.extra?.points}
        </div>
      </div>
    </div>
  );
};

export default TeamSummary;
